import { render, staticRenderFns } from "./SwitchOrdersBackground.vue?vue&type=template&id=06318557&scoped=true"
import script from "./SwitchOrdersBackground.vue?vue&type=script&lang=js"
export * from "./SwitchOrdersBackground.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrdersBackground.vue?vue&type=style&index=0&id=06318557&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06318557",
  null
  
)

export default component.exports